import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import Reports from "./views/Reports.vue";
import CEReports from "./views/CEReports.vue";
import VarillaReports from "./views/VarillaReports.vue";
// import VarillaReports2 from "./views/VarillaReports2.vue";
import PestsReports from "./views/PestsReports.vue";
import Netajet from "./views/NetajetReports.vue";
import Reservorio from "./views/Reservorio.vue";
import Paskal from "./views/Paskal.vue";
import Riego from "./views/Riego.vue";
import Joules from "./views/Joules.vue";
import Instructions from "./views/IrrigationInstructions.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/Dashboard",
      name: "Dashboard",
      component: Dashboard,
    },
    {
      path: "/Reports",
      name: "Reports",
      component: Reports,
    },
    {
      path: "/CEReports",
      name: "CEReports",
      component: CEReports,
    },
    {
      path: "/VarillaReports",
      name: "VarillaReports",
      component: VarillaReports,
    },
    // {
    //   path: "/VarillaReports2",
    //   name: "VarillaReports2",
    //   component: VarillaReports2,
    // },
    {
      path: "/PestsReports",
      name: "PestsReports",
      component: PestsReports,
    },
    {
      path: "/Netajet",
      name: "Netajet",
      component: Netajet,
    },
    {
      path: "/Reservorio",
      name: "Reservorio",
      component: Reservorio,
    },
    {
      path: "/Paskal",
      name: "Paskal",
      component: Paskal,
    },
    {
      path: "/Riego",
      name: "Riego",
      component: Riego,
    },
    {
      path: "/Joules",
      name: "Joules",
      component: Joules,
    },
    {
      path: "/Instructions",
      name: "Instructions",
      component: Instructions,
    },
  ],
});
